


const ContactHeader = () => {
  return (
    <div className="text-center mb-16">
      <h1 className="text-4xl font-bold mb-4 text-primary">Contact Us</h1>
      <p className="text-primary/80 max-w-2xl mx-auto">
        Have questions about The Mat Monster? We're here to help. Reach out to our team and we'll get back to you as soon as possible.
      </p>
    </div>
  );
};

export default ContactHeader;
